module.exports = __webpack_public_path__ + "img/weixin-share.019164ba.png";